const { BaseClient, setupClient } = require('./base-client')

const { backendUrl } = require('sci/utils')

class Client extends BaseClient {
    url (path) {
        return backendUrl(path)
    }
}

module.exports = setupClient(Client)



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/client.js